/**
 * tokenStorage.ts
 *
 * 访问令牌（access token）在 admin-web 中的唯一存储入口。
 *
 * 设计原则：
 * - 单一存储位置：只有 `localStorage[ACCESS_TOKEN_KEY]`，避免分散在多个模块各自读
 *   `localStorage` 导致键名漂移；任何前端模块需要附带 `Authorization: Bearer`
 *   时，必须经此模块读取，不得自行写 `localStorage.getItem('__jinzhuan_...')`。
 * - refresh token 由 HttpOnly Cookie 管理（PR #119），不在 localStorage 中；本模块
 *   严禁新增 refresh token 相关 API。
 * - 提供共享 `getStoredAccessToken` 给 `createApiClientAuthAdapter` 与
 *   `ErrorBoundary` 默认 reporter 共用，使 `/api/v1/error-reports` 在已登录态下
 *   可以正确携带 Bearer，避免 401（Issue #178 / PR #184 Codex review）。
 */

const ACCESS_TOKEN_KEY = '__jinzhuan_access_token__';

export const getStoredAccessToken = (): string | null => {
  try {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const storeAccessToken = (token: string): void => {
  try {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  } catch {
    // localStorage may be unavailable (private mode quota, disabled storage);
    // sign-in still proceeds — readSession() will fall back to the HttpOnly cookie.
  }
};

export const clearStoredAccessToken = (): void => {
  try {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  } catch {
    // localStorage may be unavailable; ignore — there is nothing to clean up.
  }
};
